import {getConfig} from '../lib/config.ts';
import {type PostRequestOptions, makeApiCall} from './make-api-call.ts';

export const DIFF_DISPLAY_LEVELS = {
  FULL: 'full',
  ADDED: 'added',
  REMOVED: 'removed',
  NO: 'no',
} as const;
export type DiffDisplayLevel = typeof DIFF_DISPLAY_LEVELS[keyof typeof DIFF_DISPLAY_LEVELS];

export type ViewPreferences = {
  // TODO: change this to a better name
  /** Which changes to show on the visual diff and in the changes list */
  diffDisplayLevel: DiffDisplayLevel;
  /** Overrides for the changes list filters: the key is the filter name; the value is whether it should be checked */
  diffFilterOverrides: Record<string, boolean>;
  /** Overrides for layer visibility: the key is the layer ID; the value is whether it should be visible */
  layerOverrides: Record<number, boolean>;
  /** Whether to show unchanged sheets in multipage documents the project tree */
  showUnchangedSheets: boolean;
};

type SaveViewPreferencesParams = {
  repoOwner: string;
  repoName: string;
  pullRequestNumber: number;
  viewPreferences: ViewPreferences;
};
export async function saveViewPreferences(params: SaveViewPreferencesParams, options: PostRequestOptions = {}): Promise<void> {
  const path = `${params.repoOwner}/${params.repoName}/pulls/${params.pullRequestNumber}/diff-filter-state`;

  const config = getConfig();
  const csrfToken = config.csrfToken;

  await makeApiCall({
    method: 'POST',
    path,
    headers: {
      'Content-Type': 'application/json',
      'X-Csrf-Token': csrfToken,
    },
    // ensure that we're only going to send these specific keys
    body: JSON.stringify({
      diffToggle: params.viewPreferences.diffDisplayLevel,
      filterOverrides: params.viewPreferences.diffFilterOverrides,
      layerOverrides: params.viewPreferences.layerOverrides,
      showUnchangedSheets: params.viewPreferences.showUnchangedSheets,
    }),
    keepalive: true,
  }, options);
}
